import React, {useEffect, useRef} from 'react';
import {connect} from "react-redux";
import {animateButtons, hideButtons} from "../../../../SqftUiFunctions";
import {SIDEBAR_LAYOUTS_BUTTONS} from "../../../../../constants";
import Square from "../../../../canvas/core/shapes/layouts/square";
import WideAngle from "../../../../canvas/core/shapes/layouts/wideAngle";
import Horseshoe from "../../../../canvas/core/shapes/layouts/horseshoe";
import Rectangle from "../../../../canvas/core/shapes/layouts/rectangle";
import RectangleIsland from "../../../../canvas/core/shapes/layouts/rectangleIsland";
import WideAngleReverted from "../../../../canvas/core/shapes/layouts/wideAngleReverted";
import workspace from "../../../../canvas/core/workspace";
import eventManager from "../../../../canvas/store/sqftEventManager";
import config from "../../../../canvas/store/sqftConfig";
import {toggleChangeLayoutPopup, updateSQFTCalculations} from "../../../../../../../actions/sqftFunctions";
import store from "../../../../../../../store";
import {setSQFTRoomLayouts} from "../../../../../../../actions/sqftMenuFunctions";
import {getCountertopPartNames} from "../../../../../helpers/shapeHelper";

export const setNewLayout = (layoutName) => {
  workspace.removeAllShapes();
  eventManager.stealCursor(true);
  window.setNextLayout = layoutName;
  const [countertopPartName, centerIslandPartName] = getCountertopPartNames();

  switch (layoutName) {
    case "S":
    case "SP":
      workspace.addShape(new Rectangle(), 'square', null, countertopPartName, layoutName);
      break;
    case "SI":
    case "SPI":
      workspace.addShape(new RectangleIsland(config.shapeSize), 'square', null, countertopPartName, layoutName);
      break;
    case "SN":
    case "SNI":
    case "SPN":
    case "SPNI":
      workspace.addShape(new WideAngleReverted(config.shapeSize), 'wideangle', null, countertopPartName, layoutName);
      break;
    case "L":
    case "LI":
      workspace.addShape(new WideAngle(config.shapeSize), 'wideangle', null, countertopPartName, layoutName);
      break;
    case "LN":
    case "LNI":
      workspace.addShape(new Horseshoe(config.shapeSize), 'horseshoe', null, countertopPartName, layoutName);
      break;
    default:
      break;
  }
  if (layoutName.includes("I")) {
    workspace.addShape(new Square(config.shapeSize, true), 'square', null, centerIslandPartName, layoutName);
  }

  // todo sqft-react remove?
  // nodes.layoutButtons.forEach(function (layoutButton) {
  //   layoutButton.classList.remove("shapes-icon--active");
  // });
  // document.querySelector("[data-layout='"+layoutName+"']").classList.add("shapes-icon--active");

  if (window.innerHeight < 480 && window.innerWidth < 991) {
    // todo sqft-react
    //Menu.hideSidebarSide();
    //Menu.hideSideBarContent();
  }
  const state = store.getState();
  const updateCalculations = state.sqftState.updateCalculations;

  store.dispatch(updateSQFTCalculations(updateCalculations + 1));
};

export const setRoomLayouts = (itemName) => {
  const state = store.getState();
  const roomLayouts = state.sqftMenuState.roomLayouts;
  const activeRoomIndex = state.sqftMenuState.activeRoomIndex;
  const updatedRoomLayouts = [...roomLayouts];
  const roomLayoutIndex = updatedRoomLayouts.findIndex(roomLayout => roomLayout.roomIndex === activeRoomIndex);
  if (roomLayoutIndex >= 0) {
    updatedRoomLayouts[roomLayoutIndex].layoutName = itemName;
    setSQFTRoomLayouts(updatedRoomLayouts);
  } else {
    setSQFTRoomLayouts([...roomLayouts, {roomIndex: activeRoomIndex, layoutName: itemName}]);
  }
}

const SqftNavLayouts = (props) => {
  // other popups, modals and so on
  const {menuOpened, activeButton, roomLayouts, activeRoomIndex, setSQFTRoomLayouts} = props;
  const expanded = activeButton && menuOpened === "layouts";
  const buttonRefs = useRef({});

  useEffect(() => {
    const buttons = Object.values(buttonRefs.current);
    if(expanded) {
      animateButtons(buttons);
    } else {
      hideButtons(buttons);
    }

  }, [expanded]);

  const handleButtonClick = async (event, itemName) => {
    console.log("itemName", itemName);
    event.preventDefault();
    event.stopPropagation();
    const shapesLength = workspace.getShapes().length;
    const isRoomHasLayout = roomLayouts.some(roomLayout => roomLayout.roomIndex === activeRoomIndex);

    if (isRoomHasLayout || shapesLength) {
      callChangeLayoutDataPopup(itemName, true);
      setRoomLayouts(itemName);
    } else {
      setNewLayout(itemName);
      setSQFTRoomLayouts([...roomLayouts, {roomIndex: activeRoomIndex, layoutName: itemName}]);
    }
  };

  //todo
  const callChangeLayoutDataPopup = (layoutName, applyLayoutOnSqft = false) => {
    props.toggleChangeLayoutPopup(true, layoutName, applyLayoutOnSqft);
    // window.parent.postMessage({
    //   action: SQFT_POST_MESSAGE_ACTIONS.callChangeLayoutDataPopup,
    //   payload: {
    //     layoutName,
    //     applyLayoutOnSqft
    //   }
    // }, "*");
  };

  return (
    <div className={"layouts side" + (menuOpened && activeButton && activeButton === "layouts" ? " expanded" : "")} data-side="layouts">
      <div className="shapes-list">
        {
          SIDEBAR_LAYOUTS_BUTTONS.map((item, index) => (
            <button className="button button--inner shapes-icon"
                    key={index}
                    ref={el => buttonRefs.current[index] = el}
                    data-layout={item}
                    onClick={(e) => handleButtonClick(e, item)}
            />
          ))
        }
      </div>
    </div>

  )

};

const mapStateToProps = (store) => {
  return {
    menuOpened: store.sqftMenuState.menuOpened,
    activeButton: store.sqftMenuState.activeButton,
    activeRoomType: store.sqftMenuState.activeRoomType,
    roomLayouts: store.sqftMenuState.roomLayouts,
    qtActiveCategory: store.qtState.qtActiveCategory,
    quotes: store.quotesState.quotes,
    activeRoomIndex: store.sqftMenuState.activeRoomIndex,
  };
};

const mapDispatchToProps = {
  toggleChangeLayoutPopup,
  setSQFTRoomLayouts,
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavLayouts);
